import { render, staticRenderFns } from "./GoodsAndImagePreview.vue?vue&type=template&id=b5250300&scoped=true"
import script from "./GoodsAndImagePreview.vue?vue&type=script&lang=js"
export * from "./GoodsAndImagePreview.vue?vue&type=script&lang=js"
import style0 from "./GoodsAndImagePreview.vue?vue&type=style&index=0&id=b5250300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5250300",
  null
  
)

export default component.exports